angular.module("myApp").controller("SentEmailsController", function ($scope, uuiData, Dialog, EpastaTests) {
  const popupEmail = (row) => {
    const e = uuiData.record("izsutita_vestule", row.id)
    Dialog.dialog("pages/sent-emails/sent-email.form.html", e)
  }

  $scope.view = "izsutitas_vestules_list"
  $scope.gridOptions = {
    filtersUrl: "pages/sample-filter.html",
    perPage: 50,
    noDataLabel: "Nav atrasts neviens e-pasts.",
    rowClick: popupEmail,
    buttons: [
      {
        label: "Tests",
        class: "btn-success",
        icon: "fa-check",
        click: () => {
          var opts, p
          p = {
            id: 1,
            email: void 0,
          }
          opts = {}
          return Dialog.dialog("pages/dialogs/email-test.html", p, opts, (_p, action) => {
            if (action === "save") {
              return Dialog.finish(new EpastaTests(p), $scope.reload, "Vēstule nosūtīta")
            }
          })
        },
      },
    ],
  }
  return this
})
